class SubNav {
    constructor() {
        this.subNav = document.querySelector('[id*="menu-subnav"]');
        if(!this.subNav) return;
        this.subNavItems = this.subNav ? this.subNav.querySelectorAll('li') : null;
        if(!this.subNavItems) return;
        this.toggleActiveTab();
    }

    toggleActiveTab() {
        this.subNavItems.forEach((menuItem) => {
            let link = menuItem.querySelector('a');
            if(!link) return;
            if(location.pathname === link.pathname){
                menuItem.classList.add('current-menu-item');
            }
        });
    }
}

export default new SubNav();